import React from 'react';
import styled from 'styled-components';
import { GetColor, Loading } from 'venn-ui-kit';
import Copyright from '../copyright';

const FixedContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: ${GetColor.Black};
`;

const AuthCopyright = styled(Copyright)`
  margin-top: 6px;
  text-align: center;
  color: ${GetColor.White};
`;

const AuthLoader = styled(Loading)`
  margin: 15px auto;
`;

const PageContainer = styled.div`
  height: 100vh;
  overflow-y: auto;
  overflow-x: hidden;
  display: flex;
`;

const LoaderContainer = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

export const AuthLoading = () => (
  <FixedContainer>
    <PageContainer>
      <LoaderContainer>
        <AuthLoader title="Loading..." />
        <AuthCopyright lineBreak />
      </LoaderContainer>
    </PageContainer>
  </FixedContainer>
);
